import React, {ReactElement, useCallback, useEffect, useRef, useState} from 'react'
import {SActionBtn, SAside, SLowcodeList, STableActions} from 'shj-components'
// import moment from 'moment'
import {message, Space, Switch} from 'antd'
import {
  deleteLaunchAccount,
  getAdvertWorkerList,
  getAgents,
  getBusinessLines,
  getChannels,
  getChannelTypeIds,
  getDataDictionaries,
  getDepartmentTree,
  getPlatforms,
  launchAccountList,
  queryAllDecoCompany,
  updateLaunchAccount,
} from '@/services/getUsers'
import KeepAlive from 'react-activation'
import {useLocation, useNavigate} from 'react-router-dom'
import {getCommonOptions} from '@/utils/common'
import {ModalAddOrEditDom} from './addOrEdit'
import {useSetState} from "ahooks";
import styles from './index.module.less'

const config = {
  searchMode: 'group',
  // searchTitle: '线索账号管理',
  rowSelection: false,
  columns: [
    {
      title: '投放账号ID',
      dataIndex: 'id',
      width: 200,
      fixed: 'left',
    },
    {
      title: '投放标识',
      dataIndex: 'launchIdentification',
      width: 230,
      fixed: 'left',
    },
    {
      title: '投放平台',
      dataIndex: 'platformName',
      width: 120,
    },
    {
      title: '账号ID',
      dataIndex: 'accountId',
      width: 170,
    },
    {
      title: '账号名称',
      dataIndex: 'accountName',
      width: 220,
    },
    {
      title: '归属公司',
      dataIndex: 'companyName',
      width: 150,
    },
    {
      title: '部门',
      dataIndex: 'deptName',
      width: 150,
    },
    {
      title: '优化师',
      dataIndex: 'advertName',
      width: 150,
    },
    {
      title: '军种',
      dataIndex: 'channelTypeName',
      width: 150,
    },
    {
      title: '渠道',
      dataIndex: 'channelName',
      width: 200,
    },
    {
      title: '军种总分归属',
      dataIndex: 'armyAffiliationName',
      width: 150,
    },
    {
      title: '品牌',
      dataIndex: 'channelBrandName',
      width: 150,
    },
    {
      title: '运营方式',
      dataIndex: 'operationModeName',
      width: 150,
    },
    {
      title: '代理商',
      dataIndex: 'agentName',
      width: 150,
    },
    {
      title: '是否启用',
      dataIndex: 'enableFlag',
      width: 120,
      render: 'enableFlagRender',
    },
    {
      title: '最后更新时间',
      dataIndex: 'lastUpdatedTime',
      itemType: 'dateTime',
      width: 120,
    },
    {
      title: '最后操作者',
      dataIndex: 'modifiedByName',
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 250,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'keyword',
      label: '搜索查询',
      itemType: 'input',
      placeholder: '请输入投放标识、账号名称、账号ID',
    },
    {
      name: 'companyId',
      label: '公司筛选',
      itemType: 'select',
      showSearch: true,
      events: ['onChange:onCompanyCodeChange', 'filterOption:filterOption'],
      key: 'orgId',
      labelKey: 'companyName',
      data: 'companies',
      addonOpts: [],
    },
    {
      name: 'deptId',
      label: '部门',
      itemType: 'cascader',
      events: ['onChange:onDeptCodeChange'],
      key: 'id',
      labelKey: 'label',
      value: 'id',
      data: 'deptTree',
      notFoundContent: '请选择公司或无匹配数据',
      changeOnSelect: true,
      expandTrigger: 'hover',
    },
    {
      name: 'advertId',
      label: '优化师',
      itemType: 'select',
      key: 'id',
      labelKey: 'userName',
      data: 'advertWorkers',
      notFoundContent: '请选择公司或无匹配数据',
      addonOpts: [],
    },
    {
      name: 'channelTypeId',
      label: '军种',
      data: 'channelTypeIds',
      itemType: 'select',
      key: 'id',
      labelKey: 'typeName',
      addonOpts: [],
    },
    {
      name: 'armyAffiliation',
      label: '总分归属',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'armyAffiliations',
      addonOpts: [],
    },
    {
      name: 'channelBrandId',
      label: '品牌',
      itemType: 'select',
      key: 'id',
      labelKey: 'brandName',
      data: 'businessLines',
      addonOpts: [],
    },
    {
      name: 'platformCode',
      label: '投放平台',
      itemType: 'select',
      key: 'platformCode',
      labelKey: 'platformName',
      data: 'platforms',
      addonOpts: [],
    },
    {
      name: 'operationMode',
      label: '运营方式',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'operationModes',
      addonOpts: [],
    },
    {
      name: 'agentId',
      label: '代理商',
      data: 'agents',
      itemType: 'select',
      key: 'id',
      labelKey: 'agentName',
      addonOpts: [],
    },
    {
      name: 'enableFlag',
      label: '是否启用',
      itemType: 'select',
      key: 'key',
      labelKey: 'label',
      data: 'enableFlags',
      addonOpts: [],
    },
    {
      name: 'id',
      label: '投放账号ID',
      itemType: 'input',
      placeholder: '请输入投放账号ID',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
    {
      label: '查看新增流程',
      events: ['onClick:onAddUrl'],
    },
  ],
}

function ClueAccountPage(): ReactElement<any> {
  const listRef = useRef<any>()
  // const microAppData = window.microApp.getData()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingId, setLoadingId] = useState<any>('')
  const [channelTree, setChannelTree] = useState<any>([])
  const [activeCategoryId, setActiveCategoryId] = useState<string>('')
  const [activeChannelId, setActiveChannelId] = useState<string>('')

  const [state, setState] = useSetState({
    record: {},
    open: false,
  })

  // 筛选搜索
  function filterSearchData(objOld: Record<string, any>): Record<string, any> {
    const result = {...objOld}
    if (result.deptId) {
      result.deptId = result.deptId[result.deptId.length - 1]
    }
    if (result.channelId) {
      result.channelId = result.channelId[result.channelId.length - 1]
    }
    return result
  }

  useEffect(() => {
    console.log(activeChannelId)
    listRef.current?.setParamsAttr({
      channelCategoryId: (!activeCategoryId || activeCategoryId === '0') ? undefined : activeCategoryId,
      channelId: activeChannelId ? [activeChannelId] : undefined,
    })
  }, [activeCategoryId, activeChannelId]);

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      try {
        const {current, pageSize, query} = values
        const newQuery = filterSearchData(query)
        launchAccountList(current, pageSize, newQuery).then(data => resolve(data))
      } catch (e) {
        reject({success: false})
      }
    })
  }
  // 新建 or 编辑问题
  const onAdd = (record: any) => {
    setState({record, open: true})
  }
  const reload = () => {
    const {
      current: {reload},
    } = listRef
    reload()
  }
  const onAddUrl = () => {
    window.open('https://doc.weixin.qq.com/doc/w3_AA0AqQYVAFgFq6Jmgx4QtSDZOIgw2')
  }
  // 获取下拉
  const getSelection = () => {
    return new Promise(async resolve => {
      const orgCompanyList = await getAllDecoCompany()
      const businessLines = await getBusinessLines()
      const channelTypeIds = await getChannelTypeIds()
      const channelTree = await getChannels()
      const platforms = await getPlatforms()
      const agents = await getAgents()
      const operationModes = await getDataDictionaries(
        'com.shj.saas.plus.clue.enums.account.OperationMode'
      )
      const armyAffiliations = await getDataDictionaries(
        'com.shj.saas.plus.clue.enums.ArmyAffiliation'
      )
      setChannelTree([{label: '全部分类', id: '0'}, ...channelTree])
      resolve({
        companies: orgCompanyList,
        channelTypeIds,
        channelTree,
        armyAffiliations,
        businessLines,
        platforms,
        operationModes,
        agents,
        enableFlags: [
          {
            key: 'true',
            label: '启用',
          },
          {
            key: 'false',
            label: '停用',
          },
        ],
      })
    })
  }
  const getAllDecoCompany = () => {
    return queryAllDecoCompany().then((response: any) => {
      return response
    })
  }
  const onEdit = useCallback((data: Record<string, any>) => {
    onAdd(data)
  }, [])
  const onDel = ({id}: { id: number }) => {
    deleteLaunchAccount(id).then((resp: any) => {
      message.success(resp?.message)
      reloadFn()
    })
  }
  const reloadFn = () => {
    const {
      current: {reload},
    } = listRef
    reload()
  }
  const changeEnable = (record: any, enableFlag: boolean) => {
    setLoading(true)
    setLoadingId(record.id)
    updateLaunchAccount({...record, enableFlag}).then(() => {
      setLoading(false)
      reloadFn()
    })
  }
  //
  const onCompanyCodeChange = (orgId: string) => {
    console.log(orgId, 'orgId')
    getCommonOptions({
      listRef,
      fn: () => getDepartmentTree(orgId),
      key: 'deptTree',
      isConversion: false,
    })
    // getCommonOptions({
    //   listRef,
    //   fn: () => getAdvertWorkerList({ orgCode: orgId, posType: 'PutMans' }),
    //   key: 'advertWorkers',
    //   isConversion: false,
    // })
    listRef?.current?.resetFields(['deptId', 'advertWorkerNumber'])
  }
  const onDeptCodeChange = (deptId: Array<string>) => {
    getCommonOptions({
      listRef,
      fn: () =>
        getAdvertWorkerList({
          status: true,
          userIdentityFilter: {
            orgId: deptId && deptId.length ? deptId[deptId.length - 1] : '',
          },
        }),
      key: 'advertWorkers',
      isConversion: false,
    })
    listRef?.current?.resetFields(['advertWorkerNumber'])
  }

  const onSearchReset = () => {
    listRef.current.updateSearchData('deptTree', [])
    listRef.current.updateSearchData('advertWorkers', [])
  }
  // 授权
  const targetLink = (o: any) => {
    window.open(`${o.authUrl}`)
  }
  const filterOption = (input: string, option: any) => option.children.indexOf(input) >= 0
  const extension = {
    request: {fetchList, getSelection},
    events: {onAdd, onAddUrl, onCompanyCodeChange, filterOption, onSearchReset, onDeptCodeChange},
    customRender: {
      enableFlagRender(checked: boolean, record: any) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="停用"
            checked={checked}
            loading={loading && loadingId === record.id}
            onChange={v => changeEnable(record, v)}
          />
        )
      },
      actionTool(_: any, record: any) {
        return (
          <Space size={2}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <STableActions>
                <>
                  {record.authStatus === 'GO_AUTH' ? (
                    <SActionBtn
                      style={{marginRight: '5px'}}
                      size="small"
                      onClick={() => targetLink(record)}
                    >
                      去授权
                    </SActionBtn>
                  ) : null}
                  {record.authStatus === 'AUTH_FAIL' ? (
                    <SActionBtn
                      disabled
                      style={{
                        marginRight: '5px',
                        border: '1px solid #F9B5B5',
                        background: '#FDE6E6',
                      }}
                      size="small"
                    >
                      <span style={{color: '#F25A5A'}}>授权失败</span>
                    </SActionBtn>
                  ) : null}
                  {record.authStatus === 'EXPIRE' ? (
                    <SActionBtn
                      style={{
                        marginRight: '5px',
                        border: '1px solid #F9B5B5',
                        background: '#FDE6E6',
                      }}
                      size="small"
                      onClick={() => targetLink(record)}
                    >
                      <span style={{color: '#F9B5B5'}}>授权失效</span>
                    </SActionBtn>
                  ) : null}
                  {record.authStatus === 'AUTHED' ? (
                    <SActionBtn
                      style={{
                        marginRight: '5px',
                        border: '1px solid #B5F4BE',
                        background: '#E7FBEA',
                      }}
                      disabled
                      size="small"
                    >
                      <span style={{color: '#19CA98'}}>已授权</span>
                    </SActionBtn>
                  ) : null}
                </>
                <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
              </STableActions>
            </div>
          </Space>
        )
      },
    },
  }

  const onChangeType = (node: any, info) => {
   const currentSelected = info.node
    if(currentSelected.object?.id){
      setActiveChannelId('')
      setActiveCategoryId(node[0])
    } else {
      setActiveChannelId(node[0])
      setActiveCategoryId('')
    }
  }

  return <div className={styles.container}>
    <div className={styles.aside}>
      <SAside
          treeData={channelTree}
          onSelect={onChangeType}
          title={''}
          treeType="tree"
          defaultSelectedKeys={['0']}
          fieldNames={{ title: 'label', key: 'id' }}
          header={false}
          dropItems={false}
      />
    </div>
    <div className={styles.main}>
      <SLowcodeList config={config} ref={listRef} {...extension} />
    </div>
    {state.open && <ModalAddOrEditDom onClose={() => setState({record: {}, open: false})} fn={listRef.current?.reload} {...state}/>}
  </div>
}

export const ClueAccountSet = (props: any) => {
  useEffect(() => {
  }, [])
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} saveScrollPosition="screen" id={'keep' + location.pathname}>
      <ClueAccountPage {...props} />
    </KeepAlive>
  )
}
export default ClueAccountSet
